import { Component, Input, OnInit } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute } from '@angular/router';
import { StudentIssueViewModel } from 'edu-application/dist';
import { LoginService } from 'src/app/login/login.service';
import { IssuesService } from '../issues.service';

@Component({
  selector: 'edu-student-issues-home',
  templateUrl: './student-issues-home.component.html',
  styleUrls: ['./student-issues-home.component.scss']
})
export class StudentIssuesHomeComponent implements OnInit {
  constructor(
    private issuesService: IssuesService,
    private activatedRoute: ActivatedRoute,
    private loginService: LoginService,
    private snackBar: MatSnackBar
  ) {

  }
  @Input() inputUserName: string | null = null;
  @Input() inputFullName: string | null = null;
  loading: boolean = false;
  issues: StudentIssueViewModel[] = [];
  userName: string | null = null;
  fullName: string | null = null;
  hasError: boolean = false;
  readonly: boolean = false;
  ngOnInit(): void {
    if (this.inputUserName != null) {
      this.userName = this.inputUserName;
      this.fullName = this.inputFullName;
      this.readonly = true;
    } else {
      const userName = this.activatedRoute.snapshot.queryParamMap.get('userName');
      const fullName = this.activatedRoute.snapshot.queryParamMap.get('fullName');
      if (fullName) {
        this.fullName = fullName;
      } else {
        this.fullName = this.loginService.userInfo.fullName || null;
      }
      if (userName) {
        this.userName = userName;
      } else {
        this.userName = this.loginService.userInfo.userName;
      }
      if (this.userName != this.loginService.userInfo.userName && this.loginService.userInfo.type == "student") {
        this.hasError = true;
      } else if (this.loginService.userInfo.type == "team") {
        this.readonly = true;
      }
    }
    // Call getIssues to fetch data on initialization
    this.getIssues();
  }
  async getIssues() {
    this.loading = true;
    this.hasError = false;
    try {
      this.issues = await this.issuesService.getStudentIssues(this.userName);
    } catch (e) {
      this.hasError = true;
    } finally {
      this.loading = false;
    }
  }

}
